<div class="insight-container" *ngIf="canViewInsightData()">
  <div *ngIf="!isExportingPdf" class="row">
    <div class="col-12 channel-selection">
      <div class="channel-selection-container">
        <span class="channel-selection-label">{{'INFLUENCER.labels.channel_selector' | translate}}</span>
        <demographic-source-selection [dataSources]="influencerChannelList"
                                      [(model)]="selectedChannelId"
                                      [makeSelectedItemOnTop]="false"
                                      (selectDemographicSourceEvent)="onChangeChannel($event)"
                                      [class.invisible]="!selectedChannelId">
        </demographic-source-selection>
      </div>
    </div>
  </div>

  <div *ngIf="enableInfluencerPlatform && globalChannelKpi" class="row">
    <div class="col-12 module-section">
      <kpi-report class="inf-insight-kpi-report" [kpi]="globalChannelKpi" [showKpiStatus]="true">
      </kpi-report>
    </div>
  </div>

  <div class="row">
    <div class="col-12 module-section">
      <performance-timeline [title]="lineChartTitle" [chartData]="influencerActivityLineChartData" [isFetchingData]="isFetchingPerformanceTimeline">
      </performance-timeline>
    </div>
  </div>

  <div class="row">
    <div class="col-12 module-section">
      <new-kpi [isFetchingData]="isFetchingKpi" [kpi]="influencerChannelKPIData"></new-kpi>
    </div>
  </div>

  <div class="row">
    <div class="col-12 module-section">
      <channel-reach [channelReaches]="channelReaches" 
        [selectedChannelId]="selectedChannelId" 
        [forPayingUser]="true"
        [isFetchingData]="isFetchingKpi"
        (exceedMaxChannelSelection)="onChannelReachMaxChannelSelectionExceeded()">
      </channel-reach>
    </div>
  </div>

  <div class="row insight-row">
    <div class="col-sm-12 col-xl-6 insight-col module-section">
      <follower-by-channel [isFetchingData]="isFetchingChannelFollowers" [channelFollowers]="channelFollowers" [selectedChannelId]="selectedChannelId"></follower-by-channel>
    </div>
  
    <div class="col-sm-12 col-xl-6 insight-col module-section">
      <interaction-rate-by-channel [isFetchingData]="isFetchingKpi" [channelInteractionRates]="channelInteractionRates" 
        [selectedChannelId]="selectedChannelId">
      </interaction-rate-by-channel>
    </div>
  </div>

  <div class="row insight-row">
    <div class="col-sm-12 col-xl-6 insight-col module-section">
      <follower-growth [followerGrowths]="followerGrowths" [isFetchingData]="isFetchingFollowerGrowths"></follower-growth>
    </div>
  
    <div class="col-sm-12 col-xl-6 insight-col module-section">
      <interaction-rate-development [channelInteractionRateDevelopments]="channelInteractionRateDevelopments" 
        [isFetchingData]="isFetchingChannelInteractionRateDevelopments">
      </interaction-rate-development>
    </div>
  </div>

  <div class="row">
    <div class="col-12 module-section">
      <influencer-top-exposures [isFetchingData]="isFetchingTopExposures" [platformList]="platformList" [topExposures]="topExposures" [forPayingUser]="true">
      </influencer-top-exposures>
    </div>
  </div>
  
  <div class="row">
    <div class="col-12">
      <best-performing-posts [isFetchingData]="isFetchingbestPerformingExposures" [bestPerformingPosts]="bestPerformingExposures" [forPayingUser]="true">
      </best-performing-posts>
    </div>
  </div>
</div>

<div *ngIf="showFallbackView()">
  <demographic-fallback [showNotificationPopup]="true" [messageTitle]="fallbackMsgTitle" [messageContent]="fallbackMsgContent"></demographic-fallback>
</div>

<achoo-popup #ChannelReachNotificationPopup
             [isNotification]="true"
             modelTitle="{{'notification.warning' | translate}}">
  <span>{{'INFLUENCER.insight.channel_reach.exceed_selected_channel_warning' | translate}}</span>
</achoo-popup>

<achoo-popup #ErrorPopup
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <div class="d-flex flex-column flex-auto">
    <span>
      {{errorMessage}}
    </span>
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-insight.component.html